import { Nav, NavItem, NavLink } from "reactstrap";
import { Contact, Href, Inbox, Home } from "../../../Utils/Constants";


type propsType = {
    basicTab: string;
    setBasicTab: (data: string) => void;
}

export default function ApprovalNav({ basicTab, setBasicTab }: propsType) {

    return (
        <Nav tabs className='border-tab nav-info mb-0'>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '1' ? 'active' : ''}`} onClick={() => setBasicTab('1')}><i className="icofont icofont-ui-home" />{'MTP Approval'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '2' ? 'active' : ''}`} onClick={() => setBasicTab('2')}><i className="icofont icofont-ui-message" />{'Leave Approval'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '3' ? 'active' : ''}`} onClick={() => setBasicTab('3')}><i className="icofont icofont-man-in-glasses" />{'Expense Approval'}</NavLink>
            </NavItem>
        </Nav>
    )
}
